"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FindYourNextHorizon() {
  const {
    ref: headingRef,
    isVisible: isHeadingVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: btnRef,
    isVisible: isBtnVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="262394" id="find-your-next-horizon" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/tropical_archipelago_drone.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/tropical_archipelago_drone.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/tropical_archipelago_drone.png-wvc-sizes" alt="Tropical Archipelago Aerial View" className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-primary/60 mix-blend-multiply"></div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h1 ref={headingRef} className={`font-default text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 tracking-tight max-w-4xl transition-all duration-1000 transform drop-shadow-lg uppercase ${isHeadingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          THE WORLD IS WAITING.
        </h1>
        
        <p ref={textRef} className={`font-default text-lg md:text-xl text-white/90 max-w-2xl mb-10 transition-all duration-1000 delay-200 transform drop-shadow-md ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          Discover curated expeditions to the most remote corners of the globe with Wanderlust Expeditions.
        </p>
        
        <div ref={btnRef} className={`flex flex-col sm:flex-row gap-4 w-full sm:w-auto transition-all duration-1000 delay-400 transform ${isBtnVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="text-base h-14 px-8 w-full sm:w-auto shadow-2xl bg-primary-foreground text-primary font-default rounded-md hover:scale-105 transition-transform">
            <Link to="/ExpeditionsPage">Book Your Trip</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="text-base h-14 px-8 w-full sm:w-auto bg-transparent border-white/30 text-white hover:bg-white/10 hover:text-white backdrop-blur-md font-default rounded-md">
            <Link to="/ExpeditionsPage">Explore Packages</Link>
          </Button>
        </div>
      </div>
    </section>;
}